import { render, staticRenderFns } from "./PesquisaTabelaCoparticipacao.vue?vue&type=template&id=1c2c3460&scoped=true&"
import script from "./PesquisaTabelaCoparticipacao.vue?vue&type=script&lang=js&"
export * from "./PesquisaTabelaCoparticipacao.vue?vue&type=script&lang=js&"
import style0 from "./PesquisaTabelaCoparticipacao.vue?vue&type=style&index=0&id=1c2c3460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2c3460",
  null
  
)

export default component.exports